import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { isPast } from 'date-fns';

import { DecisivePlayerPickerTaskAppearanceStatus } from '@sorare/core/src/__generated__/globalTypes';
import { isType, withFragments } from '@sorare/core/src/lib/gql';

import type {
  hasReadyTaskAppearance_taskInterface,
  isTaskLive_gameWeeklyTask,
} from './__generated__/utils.graphql';

export const isTaskLive = withFragments(
  (task: isTaskLive_gameWeeklyTask) => isPast(task.so5Fixture.cutOffDate),
  {
    gameWeeklyTask: gql`
      fragment isTaskLive_gameWeeklyTask on GameWeeklyTask {
        id
        so5Fixture {
          slug
          cutOffDate
        }
      }
    ` as TypedDocumentNode<isTaskLive_gameWeeklyTask>,
  }
);

export const hasReadyTaskAppearance = withFragments(
  (task: hasReadyTaskAppearance_taskInterface) => {
    if (!isType(task, 'DecisivePlayerPickerTask')) return false;
    if (task.taskAppearances.length < task.maxAppearancesCount) return true;
    return task.taskAppearances.some(
      appearance =>
        appearance.status === DecisivePlayerPickerTaskAppearanceStatus.READY
    );
  },
  {
    taskInterface: gql`
      fragment hasReadyTaskAppearance_taskInterface on TaskInterface {
        id
        ... on DecisivePlayerPickerTask {
          id
          maxAppearancesCount
          taskAppearances {
            id
            status
          }
        }
      }
    ` as TypedDocumentNode<hasReadyTaskAppearance_taskInterface>,
  }
);
